import React from 'react'
import { FormAntibiogram } from './FormAntibiogram';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';


export const ModalAntibiogram = (props) => {

    const {
        modal, modalTitle, toggle, method, onChangeAntibiotics, antibioticsSelected,
        validaciones,
        antibiogram, antibiotics,
        handleInputChange, loading,
        saveCreate, saveUpdate, saveDelete,
        closeDialogA
    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialogA}
            blockScroll
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icon-panel f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-2`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            onClick={saveCreate}
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                        >
                            {
                                loading ? "Creando antibiograma...." : "Crear antibiograma"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            onClick={saveUpdate}
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                        >
                            {
                                loading ? "Actualizando antibiograma...." : "Actualizar antibiograma"
                            }
                        </Button>
                    }


                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialogA}
                    >
                        Cancelar
                    </Button>

                </>
            }
        >

            {
                method === "create"
                    ? <FormAntibiogram
                        button={"Crear antibiograma"}
                        {...{ closeDialogA, loading, handleInputChange, antibiotics, onChangeAntibiotics, antibioticsSelected, validaciones, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormAntibiogram
                            button={"Actualizar antibiograma"}
                            {...{ closeDialogA, loading, handleInputChange, antibiotics, onChangeAntibiotics, antibioticsSelected, validaciones, methodAction: saveUpdate, antibiogram, }} />
                        :
                        null
            }
        </Dialog>
    )
}
